
import { defineComponent } from 'vue';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/themes';
import TableView from './components/themes/TableView.vue';
import FormState from './components/themes/FormState.vue';
import FormTags from './components/themes/FormTags.vue';

interface IState {
  state: string;
  themes: ITheme[];
  allTagNames: string[];
  allCount: number;
  pendingCount: number;
  publishedCount: number;
  rejectedCount: number;
  isTableView: boolean;
  theme: ITheme;
  isFormState: boolean;
  isFormTags: boolean;
}

export default defineComponent({
  components: { TableView, FormState, FormTags },
  data() {
    return {
      state: 'All',
      themes: [],
      allTagNames: [],
      allCount: 0,
      pendingCount: 0,
      publishedCount: 0,
      rejectedCount: 0,
      isTableView: false,
      theme: {} as ITheme,
      isFormState: false,
      isFormTags: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          state: this.state,
        },
        (res) => {
          this.themes = res.themes;
          if (this.state === 'All') {
            this.allTagNames = res.allTagNames;
            this.allCount = res.allCount;
            this.pendingCount = res.pendingCount;
            this.publishedCount = res.publishedCount;
            this.rejectedCount = res.rejectedCount;
          }
        },
      );
    },

    apiDelete(theme: ITheme) {
      api.delete(
        {
          userName: theme.userName,
          name: theme.name,
        },
        (res) => {
          if (!res) return;
          this.state = 'All';
          utils.success('模板删除成功！');
          this.apiGet();
        },
      );
    },

    getResourceState(theme: ITheme) {
      return utils.getResourceState(theme.state, theme.isFeatured);
    },

    getUrl(relatedUrl: string) {
      return `https://sscms.com/themes/${relatedUrl}`;
    },

    getDownloadUrl(theme: ITheme) {
      return `https://dl.sscms.com/themes/${theme.userName}/T_${theme.name}.zip`;
    },

    btnViewClick(theme: ITheme) {
      this.isTableView = true;
      this.theme = theme;
    },

    btnNavClick() {
      this.apiGet();
    },

    getPreviewUrl(theme: ITheme) {
      return theme.previewUrl;
    },

    btnDeleteClick(theme: ITheme) {
      utils.alertDelete(
        {
          title: '删除模板',
          text: `此操作将删除模板 ${theme.name}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(theme);
        },
      );
    },

    btnStateClick(theme: ITheme) {
      this.theme = theme;
      this.isFormState = true;
    },

    btnTagsClick(theme: ITheme) {
      this.theme = theme;
      this.isFormTags = true;
    },

    updateTheme(value: ITheme) {
      const index = this.themes.findIndex((x) => x.id === value.id);
      if (index !== -1) {
        this.themes[index] = value;
      }
      this.isFormState = false;
      this.isFormTags = false;
    },
  },
  mounted() {
    this.apiGet();
  },
});
